import React, { useState } from 'react';
import './TaxCodeForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import NumberInput from '../../../shared/NumberInput';

function TaxCodeForm({ initial, onSave, onCancel, loading }) {
  const [code, setCode] = useState(initial?.code || '');
  const [rate, setRate] = useState(initial?.rate ?? '');
  const [description, setDescription] = useState(initial?.description || '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!code.trim()) return 'Code is required.';
    if (rate === '' || isNaN(Number(rate)) || Number(rate) < 0 || Number(rate) > 100) {
      return 'Rate must be a number between 0 and 100.';
    }
    if (!description.trim()) return 'Description is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      code: code.trim().toUpperCase(),
      rate: Number(rate),
      description: description.trim(),
    });
  };

  return (
    <form className="tax-code-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={20}
            placeholder="e.g., GST"
            style={{ width: 110 }}
          />
        </div>
        <div>
          <label>Rate (%)<RequiredMark /></label><br />
          <NumberInput
            maxDecimals={4}
            min={0}
            max={100}
            step="0.01"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            style={{ width: 100 }}
          />
        </div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <label>Description<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={255}
            placeholder="e.g., Goods and Services Tax"
            style={{ width: '100%' }}
          />
        </div>
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default TaxCodeForm;
